module.exports = __webpack_public_path__ + "img/categorie-epicerie-famille-boutrais-big.09fcac5e.jpg";